import Vue from 'vue'
import App from './App'
import router from './router'

// 引用 ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 引用 axios
import axios from 'axios'
Vue.prototype.$linkage = axios

// 引用API文件
import url from './api/url/url.js'
// 将API方法绑定到全局
Vue.prototype.$http = url

Vue.config.productionTip = false

Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js